import paronApi from '@/utils/paron-api'

export default {
    // one page of the admin table: { page, perPage, filters: { search }, sortOption, order }
    getPromosPage(options) {
        return paronApi.get(paronApi.listPath('promo/all', options))
    },

    getAllPromos() {
        return paronApi.get('promo/all')
    },

    getPromoById(id) {
        return paronApi.get(`promo/${id}`)
    },

    createPromo(data) {
        return paronApi.post('promo/new', data)
    },

    editPromoById(id, data) {
        return paronApi.post(`promo/${id}/edit`, data)
    },

    deletePromoById(id) {
        return paronApi.delete(`promo/${id}`)
    }

}
